import type { ApiResponseCode } from './api-response-code'

export class ApiError extends Error {
  readonly status: number
  readonly code: ApiResponseCode | (string & {}) | undefined
  readonly details: unknown
  readonly requestId: string | undefined

  constructor(
    message: string,
    status: number,
    code?: ApiResponseCode | (string & {}),
    details?: unknown,
    requestId?: string,
  ) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.code = code
    this.details = details
    this.requestId = requestId
  }
}
